import script from "./AlbumViewPermissions.vue?vue&type=script&setup=true&lang=js"
export * from "./AlbumViewPermissions.vue?vue&type=script&setup=true&lang=js"

import "./AlbumViewPermissions.vue?vue&type=style&index=0&id=1a90f4b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a90f4b3"]])

export default __exports__